/**
 * Unified RPC Group for Doc-Cirrus Bridge
 *
 * Merges all domain-specific RPC groups into a single unified group
 */

import { RpcGroup } from "effect/rpc";
import { FrontDeskPatientInfoRpcs } from "@ascleo/frontdesk-contracts/patient-info/rpc";
import { FrontDeskKioskPolicyRpcs } from "@ascleo/frontdesk-contracts/kiosk-policy/rpc";
import { FrontDeskKioskOperationsRpcs } from "@ascleo/frontdesk-contracts/kiosk-operations/rpc";
import { FrontDeskAppointmentPrintingRpcs } from "@ascleo/frontdesk-contracts/appointment-printing/rpc";
import { PatientRpcs } from "./patient.rpc";
import { ScheduleRpcs } from "./schedule.rpc";
import { CalendarRpcs } from "./calendar.rpc";
import { CardReaderRpcs } from "./cardreader.rpc";
import { ConnectivityRpcs } from "./connectivity.rpc";
import { KimAccountRpcs } from "./kimaccount.rpc";
import { ScheduleTypeRpcs } from "./scheduletype.rpc";
import { TenantRpcs } from "./tenant.rpc";
import { FrontDeskRpcs } from "./frontdesk.rpc";

/**
 * DocCirrus Bridge RPC Group
 *
 * Unified RPC group containing all operations for the DocCirrus bridge API
 */
export class DocCirrusBridgeRpcs extends RpcGroup.make().merge(
  PatientRpcs,
  ScheduleRpcs,
  CalendarRpcs,
  CardReaderRpcs,
  ConnectivityRpcs,
  KimAccountRpcs,
  ScheduleTypeRpcs,
  TenantRpcs,
  FrontDeskRpcs,
  FrontDeskPatientInfoRpcs,
  FrontDeskKioskPolicyRpcs,
  FrontDeskKioskOperationsRpcs,
  FrontDeskAppointmentPrintingRpcs,
) {}
